const CANCEL_DROP_MODAL_DESCRIPTION_MODAL_PROPS = {
  'data-testid': 'cancel-drop-modal-description',
};

export { CANCEL_DROP_MODAL_DESCRIPTION_MODAL_PROPS };
